<template>
  <div v-if="isBannerRender" class="bannerContainer">
    <div class="bannerContent">
      <i class="fa fa-exclamation-circle bannerIcon" aria-hidden="true"></i>
      <div class="bannerText">
        <p class="bannerTitle">{{strings.ensuringSafeMeeting}}</p>
        <p class="bannerMessage">{{strings.bannerMessage}}</p>
        <a class="bannerReadMore" href="#covid-safety-regulation">{{strings.readmore}}</a>
      </div>
      <img class="icon" v-on:click="closeBanner" src="/sites/all/themes/custom/meetingpackage/templatesv3/src/assets/branded-icons/close.svg" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBanner: true,
    }
  },
  computed: {
    strings() {
      return this.$store.state.strings
    },
    isBannerRender() {
      let capacityObj = this.$store.state.venueInfo.available_capacity_percentage
      if (capacityObj) {
        return capacityObj.toggle && this.showBanner
      }
    },
    isBE() {
      return this.$store.state.isBE;
    }
  },
  methods: {
    closeBanner() {
      this.showBanner = false
    }
  }
}
</script>

<style scoped>
  @media (min-width: 319px) {
  .bannerContent {
      max-width: 540px;
    }
  }
  @media (min-width: 639px) {
    .bannerContent {
      max-width: 720px;
    }
  }
  @media (min-width: 1023px) {
    .bannerContent {
      max-width: 960px;
    }
  }
  @media (min-width: 1279px) {
    .bannerContent {
      max-width: 1100px;
    }
  }
  .bannerContainer {
    width: 100%;
    background-color: whitesmoke;
    color: inherit;
    font-family: inherit;
    padding: 0 16px;
  }

  .bannerContent {
    max-width: 1200px;
    width: 100%;
    padding: 16px 0;
    margin: auto;
    display: flex;
    flex-direction: row;
    align-items: start;
    column-gap: 24px;
  }
  .bannerText {
    width: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: start;
    position: relative;
    margin-left: auto;
  }

  .icon {
    height: 24px;
    width: 24px;
  }

  .icon:hover {
    cursor: pointer;
  }

  .bannerIcon {
    font-size: 60px;
    color: #9d9d9d;
    font-family: FontAwesome !important;
    align-self: center;
  }

  .bannerTitle {
    margin: 0;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }

  .bannerMessage {
    margin: 0;
    font-size: 16px;
    line-height: 24px;
  }
  .bannerReadMore {
    text-decoration: underline;
  }
  .bannerReadMore:hover {
    cursor: pointer;
  }
</style> 